import styled from 'styled-components';

export const DiscountPositionWrapper = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  margin-top: -2px;
  margin-left: -2px;
  pointer-events: none;
`;

export const FlashPositionWrapper = styled.div<{ offsetY: number }>`
  position: absolute;
  z-index: 100;
  margin-top: ${({ offsetY }) => `${offsetY}px`};
`;

export const CornerLabel = styled.div<{ offsetY: number; offsetX?: number }>`
  margin-top: ${({ offsetY }) => `${offsetY}px`};
  margin-left: ${({ offsetX = -5 }) => `${offsetX}px`};
  transform: rotate(-50deg);
  z-index: 10;
  pointer-events: none;
`;

export const FlashTextWrapper = styled.div`
  height: 40px;
  padding-left: 5px;
  padding-right: 5px;
  background-color: ${({ theme }) => theme.color.error};
  border-radius: 11px;
`;

export const DiscountTagWrapper = styled.div`
  position: absolute;
  width: 0;
  height: 0;

  .ant-ribbon,
  .ant5-ribbon {
    top: 0;
    right: 0;
    white-space: nowrap;
    overflow: visible !important;
  }
`;
